var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-img"},[_c('i',{staticClass:"el-icon-picture",class:{ disabled: _vm.once && _vm.lock },on:{"click":_vm.openFileSelector}}),_c('input',{ref:"file",staticClass:"file-input",attrs:{"type":"file","accept":"image/*"},on:{"input":_vm.fileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }